<div class="modal-header mx-2">
    <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
    </button>
</div>
<div class="modal-body" fxLayout="row" fxLayoutAlign="center center">
    <img [src]="imgSrc" style="max-width: 80%;">
</div>